function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function containsNonNullOrNonEmptyObject(array) {
  return array.some((element) => {
    if (element === null) return false;
    if (typeof element === 'object' && !Array.isArray(element)) {
      return !isObjectEmpty(element);
    }
    return true;
  });
}
